"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultVenue = exports.venueProblems = exports.v1Venue = exports.lacrosseField = void 0;
/**
 * Venues: where each sport is played (docs/engine-venues.md). One default
 * per sport; a caller that knows its field passes another to loadProfile.
 */
const models_1 = require("../../models");
const freeze_1 = require("../freeze");
const lacrosse_1 = require("./lacrosse");
const racquet_1 = require("./racquet");
var lacrosse_2 = require("./lacrosse");
Object.defineProperty(exports, "lacrosseField", { enumerable: true, get: function () { return lacrosse_2.lacrosseField; } });
var v1_1 = require("./v1");
Object.defineProperty(exports, "v1Venue", { enumerable: true, get: function () { return v1_1.v1Venue; } });
var validate_1 = require("./validate");
Object.defineProperty(exports, "venueProblems", { enumerable: true, get: function () { return validate_1.venueProblems; } });
const DEFAULT_VENUES = (0, freeze_1.deepFreeze)(Object.fromEntries(models_1.Sports.map((sport) => [sport, sport === "LACROSSE" ? (0, lacrosse_1.lacrosseField)("ncaaWomens") : (0, racquet_1.racquetVenue)(sport)])));
/** The regulation court for a racquet sport; the NCAA women's half-field for lacrosse. */
const defaultVenue = (sport) => DEFAULT_VENUES[sport];
exports.defaultVenue = defaultVenue;
